import { render, staticRenderFns } from "./promotionStatus.vue?vue&type=template&id=d99b77f6&scoped=true"
import script from "./promotionStatus.vue?vue&type=script&lang=js"
export * from "./promotionStatus.vue?vue&type=script&lang=js"
import style0 from "./promotionStatus.vue?vue&type=style&index=0&id=d99b77f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99b77f6",
  null
  
)

export default component.exports